export const AudioModule = () => null;